import logo from 'assets/logo-prosinergia-wh.svg';
import { useAppSelector } from 'hooks/reduxHooks';
import { AdminRole } from 'constants/enums/roles';
import { globalPaths } from 'constants/routePaths';
import { Link } from 'react-router';

export const SiderLogo: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);

  const img = logo;

  return (
    <div className="sider-logo-div" data-cy="home-logo">
      {user && user.role !== AdminRole ? (
        <img src={img} alt="Designa" width={220} height={200} />
      ) : (
        <Link className="sider-logo-link" to={`${globalPaths.basePath}`}>
          <img src={img} alt="Designa" width={220} height={200} />
        </Link>
      )}
    </div>
  );
};
